module.exports = __webpack_public_path__ + "img/kefu@3x.80b49e7a.png";